/*
 *  Custom material-ui theme for Ourisman Travel.
 */

export default {
  spacing: {
    iconSize: 24,
    desktopGutter: 24,
    desktopGutterMore: 32,
    desktopGutterLess: 16,
    desktopGutterMini: 8,
    desktopKeylineIncrement: 64,
    desktopDropDownMenuItemHeight: 32,
    desktopDropDownMenuFontSize: 15,
    desktopDrawerMenuItemHeight: 48,
    desktopSubheaderHeight: 48,
    desktopToolbarHeight: 56
  },
  fontFamily: "Noto Sans,sans-serif",
  palette: {
    primary1Color: "#000000",
    primary2Color: "#212121",
    primary3Color: "#DDDDDD",
    accent1Color: "#da2128",
    accent2Color: "#ff5e52",
    accent3Color: "#a00000",
    textColor: "#212121",
    secondaryTextColor: "#dddddd",
    alternateTextColor: "#997e35",
    canvasColor: "#ffffff",
    alternateСanvasColor: "#484848",
    alternate1Color: "rgba(255, 255, 255, 0.54)",
    alternate2Color: "#f5f5f5",
    borderColor: "#bdbdbd",
    disabledColor: "rgba(0,0,0,0.3)",
    pickerHeaderColor: "#00bcd4",
    clockCircleColor: "rgba(0,0,0,0.07)",
    shadowColor: "#484848",
    fired: "#fb4c2f",
    insideCircle: "#4986e7",
    lowPriority: "#DDDDDD",
    needsTraining: "#fbe983",
    needsVetting: "#2da2bb",
    highPriority: "#deadbf"
  }
};



// WEBPACK FOOTER //
// /src/ourismanTravelTheme.js